import ExcelJS from 'exceljs'

export const populateTemplatePositions = async (dataList, language) => {
	const templateFile = 'https://assets.mydna.company/template/Banda Salarial Posicion - MyDNA.xlsx'

	const workbook = new ExcelJS.Workbook()

	const response = await fetch(templateFile)
	const buffer = await response.arrayBuffer()
	await workbook.xlsx.load(buffer)

	const worksheet = workbook.getWorksheet(1)

	worksheet.getCell('O2').value = language

	let startRow = 3
	dataList.forEach((data, index) => {
		const row = worksheet.getRow(startRow)

		row.getCell('A').value = data.job_name || '-'
		row.getCell('B').value = data.area || '-'
		row.getCell('C').value = data.country || '-'
		row.getCell('D').value = Number(data.salary) || '-'
		row.getCell('H').value = Number(data.smtm_market_salary) || '-'

		const dividendCell = `D${startRow}`
		const divisorCell1 = `H${startRow}`

		row.getCell('L').value = {
			formula: `IFERROR(${dividendCell}/${divisorCell1} - 1, "-")`,
			result: null,
		}

		const columns = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))
		columns.forEach(column => {
			row.getCell(column).alignment = { horizontal: 'center' }
		})

		row.commit()
		startRow++
	})

	const updatedFile = await workbook.xlsx.writeBuffer()
	const blob = new Blob([updatedFile], { type: 'application/octet-stream' })
	const url = URL.createObjectURL(blob)

	const link = document.createElement('a')
	link.href = url
	link.download = 'salary_band_positions.xlsx'
	link.click()
}
